import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomerActions } from './customer.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from '@core/services/customer.service';

@Injectable()
export class CustomerEffects {
  private actions$ = inject(Actions);
  private customerService = inject(CustomerService);
  private translateService = inject(TranslateService);
  getCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.loadCustomers),
      mergeMap((data) =>
        this.customerService.getCustomers(data).pipe(
          map((customers) =>
            customers.success
              ? CustomerActions.loadCustomersSuccess(customers)
              : CustomerActions.loadCustomersFailure(customers)
          ),
          catchError((error) =>
            of(
              CustomerActions.loadCustomersFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.addEditCustomer),
      mergeMap((data) =>
        this.customerService.addCustomer(data.customer).pipe(
          map((customer) => {
            if (customer.success) {
              return data.customer.id
                ? CustomerActions.updateCustomerSuccess(customer)
                : CustomerActions.addCustomerSuccess(customer);
            } else return CustomerActions.addCustomerFailure(customer);
          }),
          catchError((error) =>
            of(
              CustomerActions.addCustomerFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.deleteCustomer),
      mergeMap((data) =>
        this.customerService.deleteCustomer(data.id).pipe(
          map((response) =>
            response.success
              ? CustomerActions.deleteCustomerSuccess({
                  ...response,
                  id: data.id,
                })
              : CustomerActions.deleteCustomerFailure(response)
          ),
          catchError((error) =>
            of(
              CustomerActions.deleteCustomerFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  getCustomerType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.loadCustomerType),
      mergeMap(() =>
        this.customerService.getCustomerType().pipe(
          map((types) =>
            types.success
              ? CustomerActions.loadCustomerTypeSuccess(types)
              : CustomerActions.loadCustomerTypeFailure(types)
          ),
          catchError((error) =>
            of(
              CustomerActions.loadCustomerTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addCustomerType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.addEditCustomerType),
      mergeMap((data) =>
        this.customerService.addCustomerType(data).pipe(
          map((types) => {
            if (types.success) {
              return data.id
                ? CustomerActions.updateCustomerTypeSuccess(types)
                : CustomerActions.addEditCustomerTypeSuccess(types);
            } else return CustomerActions.addEditCustomerTypeFailure(types);
          }),
          catchError((error) =>
            of(
              CustomerActions.addEditCustomerTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteCustomerType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerActions.deleteCustomerType),
      mergeMap((data) =>
        this.customerService.deleteCustomerType(data.id).pipe(
          map((response) =>
            response.success
              ? CustomerActions.deleteCustomerTypeSuccess({
                  ...response,
                  id: data.id,
                })
              : CustomerActions.deleteCustomerTypeFailure(response)
          ),
          catchError((error) =>
            of(
              CustomerActions.deleteCustomerTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
